<script>
  import StatusHistoryCard from "./StatusHistoryCard.vue";
  import SidebarHeader from "./SidebarHeader.vue";
  import SidebarEmptyState from "../molecules/SidebarEmptyState.vue";

  export default {
    name: "SidebarUserStatus",
    components: {
      StatusHistoryCard,
      SidebarHeader,
      SidebarEmptyState,
    },
    props: {
      showSidebar: Boolean,
      data: Array,
      title: String,
      optionsDisabled: Object,
    },
    data() {
      return { sidebarClass: "", displayUserStatusDic: { disable: "Inactivación", enable: "Activación", license: "Licencia", disableAutomated: "Inactivación" } };
    },
    methods: {
      close() {
        this.$emit("closeSidebar");
      },
      handleClickOutside(event) {
        const sidebar = this.$refs.sidebarRef;
        if (sidebar && !sidebar.contains(event.target)) this.close();
      },
      runTransitionPhase(nextClass) {
        this.$nextTick(() => {
          setTimeout(() => {
            this.sidebarClass = nextClass;
          }, 10);
        });
      },
    },
    watch: {
      showSidebar(val) {
        const phase = val ? "enter" : "leave";
        this.sidebarClass = `sidebar-${phase}-from`;
        this.runTransitionPhase(`sidebar-${phase}-to`);
      },
    },
    mounted() {
      document.addEventListener("mousedown", this.handleClickOutside);
      document.addEventListener("touchstart", this.handleClickOutside);
    },
    beforeUnmount() {
      document.removeEventListener("mousedown", this.handleClickOutside);
      document.removeEventListener("touchstart", this.handleClickOutside);
    },
  };
</script>

<template>
  <transition name="slideAnimation" appear>
    <aside v-show="showSidebar" ref="sidebarRef" :class="['sidebarReason', sidebarClass]">
      <SidebarHeader icon="historyIcon" :title="title" @close="close" />
      <div v-if="data.length" class="sidebarReason__content">
        <StatusHistoryCard
          v-for="(item, idx) in data"
          :key="idx"
          :user="item.performedBy"
          :eventType="displayUserStatusDic[item.eventType]"
          :reason="item.reason"
          :tags="item.tags"
          :description="item.description"
          :date="item.eventDate"
          :optionsDisabled="optionsDisabled"
          :startDate="item?.startDate"
          :endDate="item?.endDate"
          :type="item.eventType"
          variant="compact" />
      </div>
      <SidebarEmptyState v-else message="No hay cambios de estado" />
    </aside>
  </transition>
</template>

<style lang="scss">
  .sidebarReason {
    position: fixed;
    top: 67px;
    right: 0px;
    width: 100%;
    max-width: 350px;
    height: 93%;
    padding: $space-16;
    display: flex;
    flex-direction: column;
    gap: $space-12;
    background-color: #fff;
    box-shadow: -2px 0 5px rgba(64, 64, 64, 0.25);
    z-index: 1000;

    ::-webkit-scrollbar {
      width: 3px;
    }
    ::-webkit-scrollbar-thumb {
      background-color: $border-inputs;
    }

    &__content {
      @include Flex(column, unset, unset);
      gap: $space-16;
      padding-right: $space-8;
      width: 100%;
      overflow-y: auto;
    }
  }

  .sidebar-enter-from,
  .sidebar-leave-to {
    transform: translateX(100%);
    opacity: 0;
    transition:
      transform 0.4s ease,
      opacity 0.4s ease;
  }
  .sidebar-enter-to,
  .sidebar-leave-from {
    transform: translateX(0);
    opacity: 1;
    transition:
      transform 0.4s ease,
      opacity 0.4s ease;
  }
</style>
